import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

// 11 telas dependem destes nomes de variante (plano de redesign §3.3) —
// preservados. Mapeados pro `.chip` do handoff, que ja embute
// white-space:nowrap (selo nunca quebra dentro da pilula).
export type BadgeVariant =
  | "default"
  | "secondary"
  | "success"
  | "warning"
  | "destructive"
  | "outline"
  | "live"
  | "draft"
  | "unpublished"
  | "error";

const variantClass: Record<BadgeVariant, string> = {
  default: "chip--coral",
  secondary: "",
  success: "chip--good",
  live: "chip--good",
  warning: "chip--warn",
  unpublished: "chip--warn",
  destructive: "chip--bad",
  error: "chip--bad",
  draft: "",
  outline: "",
};

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant = "default", className, ...rest }: BadgeProps): JSX.Element {
  return <span className={cn("chip", variantClass[variant], className)} {...rest} />;
}
